export * from './ui/tabs';
export * from './ui/tabs-content';
export * from './ui/tabs-list';
export * from './ui/tabs-trigger';
